export const sizeStyles = {
  xs: 'rounded-md px-2 py-1 text-xs',
  sm: 'rounded-md h-9 px-3 text-sm',
  base: 'rounded-md h-10 px-4 py-2 text-sm',
  lg: 'rounded-md h-11 px-8 text-sm',
  xl: 'rounded-md px-3.5 py-2.5 text-sm',
  icon: 'h-10 w-10',
};

export type SizeKey = keyof typeof sizeStyles;
